export default {
	parseAndTranslate(data, i18n) {
		const errorsArray = this._parseToArrayOfStrings(data, i18n)
		return errorsArray.map(error => this._translate(error, i18n))
	},

	_parseToArrayOfStrings(data, i18n) {
		// TODO Pridat sem loggly na data

		if (typeof data?.response?.data?.error_data == 'object') {
			return Object.values(data?.response?.data?.error_data).map(error => error)
		}

		if (typeof data == 'string') {
			return [data]
		}

		if (data && data.error && typeof data.error == 'string') {
			return [data.error]
		}

		if (data && data.error && typeof data.error == 'object') {
			return Object.values(data.error)
		}

		if (data?.data && data?.data?.error && typeof data?.data?.error == 'string') {
			return [data.data.error]
		}

		if (data && data?.data && data?.data?.error && typeof data?.data?.error == 'object') {
			return Object.values(data?.data?.error).map(error => error + ' ')
		}

		if (data?.statusText) {
			return [data.statusText]
		}

		if (import.meta.env.MODE === 'development') {
			console.error('Error parsing', data)
		}

		return ['An unexpected error has occurred. Please try again later.']
	},

	_translate(value, i18n) {
		if (!i18n) return value

		return i18n.t(value)
	}

}